import {
  AutocompleteInput,
  Create,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  Filter,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Resource,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  minValue,
  required,
} from "react-admin";
import { TRIMMING_UNITS } from "../consts";

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Article category"
      source="articleCategoryId"
      reference="articleCategory"
      alwaysOn
      filterToQuery={searchText => ({ name: searchText })}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const DefaultArticleTrimmingList = (props) => (
  <List {...props} filters={Filters(props)}>
    <div style={{ marginTop: "15px" }}>
      <Datagrid rowClick="show">
        <TextField source="id" />
        <ReferenceField
          label="Article category"
          source="articleCategoryId"
          reference="articleCategory"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          label="Trimming"
          source="trimmingId"
          reference="trimming"
        >
          <TextField source="name" />
        </ReferenceField>
        <NumberField source="quantity" label="Quantity" />
        <TextField source="unit" label="Unit" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        <EditButton />
      </Datagrid>
    </div>
  </List>
);

const ShowDefaultArticleTrimming = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField
        label="Article category"
        source="articleCategoryId"
        reference="articleCategory"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Trimming"
        source="trimmingId"
        reference="trimming"
      >
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="quantity" label="Quantity" />
      <TextField source="unit" label="Unit" />
      <DateField source="createdAt" label="Creation date" />
      <DateField source="updatedAt" label="Update date" />
    </SimpleShowLayout>
  </Show>
);

const CreateDefaultArticleTrimming = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Article category"
        source="articleCategoryId"
        reference="articleCategory"
        filterToQuery={searchText => ({ name: searchText })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Trimming"
        source="trimmingId"
        reference="trimming"
        filterToQuery={searchText => ({ name: searchText })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <NumberInput
        source="quantity"
        label="Quantity"
        validate={[required(), minValue(0)]}
      />
      <SelectInput
        source="unit"
        label="Unit"
        choices={TRIMMING_UNITS}
        validate={[required()]}
      />
    </SimpleForm>
  </Create>
);

const EditDefaultArticleTrimming = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Article category"
        source="articleCategoryId"
        reference="articleCategory"
        filterToQuery={searchText => ({ name: searchText })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Trimming"
        source="trimmingId"
        reference="trimming"
        filterToQuery={searchText => ({ name: searchText })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <NumberInput
        source="quantity"
        label="Quantity"
        validate={[required(), minValue(0)]}
      />
      <SelectInput
        source="unit"
        label="Unit"
        choices={TRIMMING_UNITS}
        validate={[required()]}
      />
    </SimpleForm>
  </Edit>
);

const defaultArticleTrimmingResource = () => (
  <Resource
    name="defaultArticleTrimmings"
    options={{ label: "Default Article Trimming", menuGroup: "Bcome" }}
    list={DefaultArticleTrimmingList}
    create={CreateDefaultArticleTrimming}
    edit={EditDefaultArticleTrimming}
    show={ShowDefaultArticleTrimming}
  />
);

export default defaultArticleTrimmingResource;
